// Port of api/fuel/app/classes/filter/search/games/filters/query/comment/commented.php
export default {
	name: 'comment.commented',
	priority: 81,
	require: function(config, filter) {
		return !!filter.commented
	},
	run: function(config, filter, data, query) {
		if (filter.commented === 1 || filter.commented === 'yes') {
			query.exist('comment', 'm')
		} else if (filter.commented === 'no') {
			query.notexist('comment', 'mn')
		}
	}
}
